import type {ComputedRef} from 'vue';
import {computed} from 'vue';
import {pageSymbol} from '../middleware/sofie-page';
import type {Page} from '../index';

export function useSofiePage(): ComputedRef<Page> {
  const route = useRoute();

  return computed<Page>(() => {
    if (!route.meta[pageSymbol]) {
      throw new Error('Not in page context, did you forget the page middleware?');
    }

    return route.meta[pageSymbol] as Page;
  });
}

export function useSofiePageWhenAvailable(): ComputedRef<Page | null> {
  const route = useRoute();

  return computed<Page>(() => route.meta[pageSymbol] as Page);
}
